"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bootstrapTemplates = void 0;
const ui_editor_data_access_projects_1 = require("@desygner/ui-editor-data-access-projects");
function bootstrapTemplates(config) {
    (0, ui_editor_data_access_projects_1.createProjectInjector)(config);
}
exports.bootstrapTemplates = bootstrapTemplates;
//# sourceMappingURL=appBootstrap.js.map